import React from 'react';

import styles from './WhyChooseUsCard.module.css';

const WhyChooseUsCard = ({ desktop_image = '', value = '', description_value = '' }) => {
  return (
    <div className={`${styles.container} text-center w-100`}>
      <img
        style={{ filter: 'invert()' }}
        className={styles.cardImage}
        src={desktop_image}
        alt="Why Choose Us Image"
        aria-label="Why choose us card content"
      />
      <h3 style={{ color: 'var(--corporative-yellow)' }} className={styles.cardTitle}>
        {value}
      </h3>
      <p className={`px-0 mx-0 ${styles.cardParagraph}`}>{description_value}</p>
    </div>
  );
};

export default WhyChooseUsCard;
